import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PremiumUpsellCard = ({ title, description, icon: Icon = Sparkles, testid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="relative rounded-2xl border border-[#FF6B35]/40 p-5 overflow-hidden"
         style={{ background: 'radial-gradient(40% 60% at 85% 20%, rgba(255,107,53,0.14) 0%, rgba(255,107,53,0) 65%), #12161B' }}
         data-testid={testid}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#FF6B35]/15 flex items-center justify-center shrink-0">
          <Icon className="w-5 h-5 text-[#FF6B35]" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h4 className="font-semibold">{title}</h4>
            <span className="label-eyebrow text-[#FF6B35] border border-[#FF6B35]/40 rounded-full px-2 py-0.5">{t('upsell.pro')}</span>
          </div>
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
          <Button onClick={() => navigate('/pricing')}
            className="mt-3 bg-[#FF6B35] hover:bg-[#FFB020] text-black font-semibold rounded-xl"
            data-testid="upsell-upgrade-btn">
            <Lock className="w-4 h-4 mr-1.5" /> {t('upsell.unlockWithPro')}
          </Button>
        </div>
      </div>
    </div>
  );
};
